import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

const HeroSectionOwner = ({ onRegisterClick }) => {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-card rounded-2xl border border-border px-4 md:px-6 lg:px-8 py-12 md:py-16">
      <div className="max-w-4xl mx-auto text-center space-y-6">
        <div className="flex justify-center">
          <div className="flex items-center justify-center w-20 h-20 rounded-2xl bg-primary/10">
            <Icon name="PlusCircle" size={40} color="var(--color-primary)" />
          </div>
        </div>

        <div className="space-y-4">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground">
            {t('hero_owner.title')}
          </h1>
          <p className="text-muted-foreground max-w-xl mx-auto text-lg">
            {t('hero_owner.subtitle')}
          </p>
        </div>

        <div className="flex justify-center pt-4">
          <button
            onClick={onRegisterClick}
            className="flex items-center justify-center gap-3 px-10 py-5 bg-primary text-primary-foreground rounded-xl hover:bg-primary/90 transition-all shadow-lg hover:scale-[1.02]"
          >
            <Icon name="Briefcase" size={24} color="currentColor" />
            <span className="text-xl font-semibold">
              {t('hero_owner.button')}
            </span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSectionOwner;